import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PathLink from "../../shared/seo/PathLink";
import { urls, currentLang } from "../../shared/seo/links";
import "./home.css";

const POPULAR = ["tunis", "sfax", "sousse", "nabeul", "bizerte", "monastir"].map(urls.findGovernorate);

export default function SearchHome() {
  const Lng = currentLang();
  const [state, setState] = useState("");
  const [name, setName] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Name and city are both optional: no city searches all of Tunisia. The
  // city is in the URL; the name travels in the history state (Lawyers.jsx).
  function goToLawyers(searchName, searchState) {
    navigate(urls.lawyersPath(Lng, { governorate: searchState || undefined }), {
      state: searchName ? { name: searchName } : undefined,
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    goToLawyers(name.trim(), state);
  }

  return (
    <section className="avc-hero">
      <div className="container avc-hero__inner">
        <span className="avc-eyebrow">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
          {t("home_eyebrow")}
        </span>
        <h1 className="avc-hero__title">{t("find_lawyer_near_you")}</h1>
        <p className="avc-hero__lead">{t("find_lawyer_near_you_description")}</p>

        <form className="avc-search" onSubmit={onSubmit} role="search">
          <label className="avc-search__field avc-search__field--name">
            <span className="avc-search__label">
              {t("home_search_name_label")}
            </span>
            <span className="avc-search__control">
              <i className="fas fa-user-tie" aria-hidden="true"></i>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t("ex")}
              />
            </span>
          </label>
          <label className="avc-search__field avc-search__field--city">
            <span className="avc-search__label">
              {t("home_search_city_label")}
            </span>
            <span className="avc-search__control">
              <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
              <select value={state} onChange={(e) => setState(e.target.value)}>
                <option value="">{t("home_all_cities")}</option>
                {urls.GOVERNORATES.map((gov) => (
                  <option key={gov.key} value={gov.key}>
                    {urls.governorateName(gov, Lng)}
                  </option>
                ))}
              </select>
            </span>
          </label>
          <button type="submit" className="avc-search__btn">
            <i className="fas fa-search" aria-hidden="true"></i>
            <span>{t("search")}</span>
          </button>
        </form>

        <div className="avc-hero__popular">
          <span className="avc-hero__popular-label">
            {t("home_popular_cities")}
          </span>
          {POPULAR.map((gov) => (
            <PathLink
              key={gov.key}
              to={urls.lawyersPath(Lng, { governorate: gov })}
              className="avc-chip"
            >
              {urls.governorateName(gov, Lng)}
            </PathLink>
          ))}
        </div>
      </div>

      <div className="avc-trust">
        <div className="container avc-trust__inner">
          <div className="avc-trust__item">
            <i className="fas fa-map-marked-alt" aria-hidden="true"></i>
            <span>{t("home_trust_states")}</span>
          </div>
          <div className="avc-trust__item">
            <i className="far fa-calendar-check" aria-hidden="true"></i>
            <span>{t("home_trust_booking")}</span>
          </div>
          <div className="avc-trust__item">
            <i className="fas fa-gavel" aria-hidden="true"></i>
            <span>{t("home_trust_advice")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
